export default __webpack_public_path__ + "static/media/icon_close_20_Regular.dab45b00.svg";